import { render, staticRenderFns } from "./users-category-modal.vue?vue&type=template&id=32a37168&scoped=true"
import script from "./users-category-modal.vue?vue&type=script&lang=js"
export * from "./users-category-modal.vue?vue&type=script&lang=js"
import style0 from "./users-category-modal.vue?vue&type=style&index=0&id=32a37168&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32a37168",
  null
  
)

export default component.exports